import React from 'react';
import { Title, InfoWrapper } from '../../TopicFilters/TopicFilters.styles';

const TopBarSmall: React.FC<{
  title: string;
  isSmallScreen?: boolean;
  simpleTextTopBar?: boolean;
}> = (props) => {
  const { title, isSmallScreen, simpleTextTopBar } = props;
  return (
    <InfoWrapper>
      <Title isSmallScreen={isSmallScreen} simpleTextTopBar={simpleTextTopBar}>
        {title}
      </Title>
    </InfoWrapper>
  );
};

export default TopBarSmall;
